import { render, staticRenderFns } from "./ManagePartners.vue?vue&type=template&id=60f6789b&scoped=true"
import script from "./ManagePartners.vue?vue&type=script&lang=js"
export * from "./ManagePartners.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=60f6789b&prod&scoped=true&lang=css&external"
import style1 from "./ManagePartners.vue?vue&type=style&index=1&id=60f6789b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6789b",
  null
  
)

export default component.exports